export default __webpack_public_path__ + "static/media/bg_252619603.a2afa861.webp";